import { useSelector } from 'react-redux';
import { selectors } from "../../redux";

const useRemoteIframe = () => {
    return useSelector(selectors.remoteIframe.getRemoteIframe);
}

export default useRemoteIframe;